// ============================================================================
// Traduction des refus serveur à la création d'une analyse — logique PURE
// (testée sans i18n : la fonction de traduction est injectée). Les messages
// serveur sont en français et littéraux : seul leur début, stable, est reconnu.
// ============================================================================

/**
 * Création asynchrone (2026-08-05) : une seule analyse en calcul par
 * utilisateur. Le conflit arrive avec extensions.code INTERNAL_SERVER_ERROR
 * (pas CONFLICT) — seul le message serveur, littéral et stable, le signale.
 */
const CONFLICT_MARKER = 'Une analyse est déjà en cours';

/**
 * Refus de `createVestiaireAnalysis` pour un plan sans accès (2026-10-01, contrat
 * `docs/superpowers/api-changelog/2026-10-01-vestiaire-acces-par-plan.md`) : début
 * stable du message serveur français, rendu par `vestiaireSearch.lockedHint`.
 */
const VESTIAIRE_LOCKED_PREFIX = 'La recherche Vestiaire Collective';

/** Message quota affiché au blocage (pré-check front OU refus serveur). */
export const QUOTA_ERROR_MESSAGE = 'Limite mensuelle atteinte! passe au plan supérieur pour continuer.';

/** Message affiché pour un échec de création ; `translate` = `i18n.t` (injecté pour les tests). */
export const resolveCreateErrorMessage = (error: unknown, translate: (key: string) => string): string => {
  const message = error instanceof Error ? error.message : '';
  if (message.includes(CONFLICT_MARKER)) {
    return translate('analysisMenu.createConflict');
  }
  if (message.startsWith(VESTIAIRE_LOCKED_PREFIX)) {
    return translate('vestiaireSearch.lockedHint');
  }
  // Refus de quota/permission côté serveur (message v1 en anglais)
  if (message.includes("don't have permission")) {
    return QUOTA_ERROR_MESSAGE;
  }
  return message || translate('analysisMenu.createError');
};
